import React from 'react';
import PropTypes from 'prop-types';
import FilterDropDown from './FilterDropDown';
import { isValidUrl } from '../util/urlUtils';

class URLRunSelector extends React.Component {
    constructor(props) {
        super(props);
        this.runUrlChangeHandler = this.runUrlChangeHandler.bind(this);
    }
    
    runUrlChangeHandler(urlItem) {
        let url = '';
        let siteId = null;
        let startUrlValid = false;
        
        if (urlItem) {
            url = urlItem.label || '';
            siteId = urlItem.site_id || null;
            
            // If the url is empty, we allow it to be valid so no error message is shown
            if (isValidUrl(url) || !url) {
                startUrlValid = true;
            }
        }
        
        this.props.onUrlChange(url, siteId, startUrlValid);
    }

    setText(text) {
        if (this.startUrlSelector.current) {
            this.startUrlSelector.current.setState({ text });
            this.startUrlSelector.current.handleInputChange(text);
        }
    }

    render() {
        return (
            <FilterDropDown 
                ref={instance => { this.startUrlSelector = instance; }} 
                items={(this.props.jobDefinition?.job_urls ?? []).map(p => ({ 
                    id: p.id, 
                    name: p.start_url, 
                    site_id: p.site_id 
                }))} 
                value={this.props.runUrl}
                placeholder="Type to filter the list or enter a new URL" 
                noMatchesMessage="No matching configured urls, but you can run with any valid URL" 
                allowFreeText={true} 
                allowNew={false} 
                displayId={false}
                isInvalid={!this.props.startUrlValid}
                validationMessage="Please enter a valid URL"
                onSelect={this.runUrlChangeHandler} 
            />
        );
    }
}

URLRunSelector.propTypes = {
    jobDefinition: PropTypes.object,
    onUrlChange: PropTypes.func.isRequired,
    runUrl: PropTypes.string,
    runSiteId: PropTypes.string
};

export default URLRunSelector; 